import React, { useEffect, useState } from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import SubdirectoryArrowLeftIcon from '@mui/icons-material/SubdirectoryArrowLeft';
import { useStore } from '../../../store/store';
import { observer } from 'mobx-react';
import { useQueryParam, NumberParam } from 'use-query-params';
import { createUseStyles } from 'react-jss';
import PageNavigation from './PageNavigation';
import PreviewButtons from './PreviewButtons';
import { TTreeItemDataViewModel, TTreeViewModel } from '../../../services/models/CourseViewModels';
import { TPageViewModel } from '../../../services/models/PageViewModel';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import ShareLinkDialog from '../../previewCourse/ShareLinkDialog';

interface TopBarProps {
  editMode?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  topBar: {
    flex: '0 1 auto',
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.bgOne.contrastText,
    background: theme.palette.bgOne.main,
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
    height: 50,
  },
}));

export default observer(function TopBar({ editMode }: TopBarProps) {
  const { courseStore, pageStore, previewStore } = useStore();
  const { loadCourseViewModel, courseViewModel, clearCourseViewModel } = courseStore;
  const { getPage, getCoursePage, openPagePreview } = pageStore;
  const { openCoursePreview } = previewStore;
  const [courseIDParam] = useQueryParam('courseID', NumberParam);
  const [isShareDialogOpen, setIsShareDialogOpen] = useState(false);
  const [pageStateParam, setPageStateParam] = useQueryParam('pageState', NumberParam);
  const [currentPage, setCurrentPage] = useState<TTreeViewModel>();
  const [coursePage, setCoursePage] = useState<TPageViewModel>();
  const [nextPage, setNextPage] = useState<number>();
  const [previousPage, setPreviousPage] = useState<number>();

  const theme = useTheme();
  const classes = useStyles({ theme });

  if (!courseIDParam) {
    return (
      <AppBar position='static' className={classes.topBar}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>
          <Tooltip title='Home'>
            <IconButton size='small' component={Link} to={'/'} style={{ color: 'inherit' }} onClick={clearCourseViewModel}>
              <HomeIcon />
            </IconButton>
          </Tooltip>
        </div>
      </AppBar>
    );
  }

  return (
    <AppBar position='static' className={classes.topBar}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>
        <Tooltip title='Home'>
          <IconButton size='small' component={Link} to={'/'} style={{ color: 'inherit' }} onClick={clearCourseViewModel}>
            <HomeIcon />
          </IconButton>
        </Tooltip>
        {editMode && (
          <>
            <Tooltip title='Back'>
              <IconButton size='small' component={Link} to={`/course?courseID=${courseIDParam}`} style={{ color: 'inherit' }}>
                <SubdirectoryArrowLeftIcon style={{ transform: 'rotate(90deg)' }} />
              </IconButton>
            </Tooltip>
            <PageNavigation courseID={courseIDParam} />
          </>
        )}
        <PreviewButtons editMode={editMode ?? false} openPagePreview={openPagePreview} openCoursePreview={openCoursePreview} openShareDialog={() => setIsShareDialogOpen(true)} />
      </div>
      {courseIDParam && isShareDialogOpen ? (
        <ShareLinkDialog open onClose={() => setIsShareDialogOpen(false)} courseId={courseIDParam} coursePageId={editMode ? pageStore.coursePage?.coursePageID : undefined} />
      ) : null}
    </AppBar>
  );
});
